export const imageFitVariants = ["contain", "cover", "fill"];
export const imageFitDescriptions = [
    "(contain: changes width and height to make sure image fits inside, saving proportions)",
    "(cover: changes width and height to fill all space, saving proportions)",
    "(fill: changes width and height to fill all space, NOT saving proportions)"
];
export const settings = {
    zoom: 1,
    collapseSettings: false,
    roundImage: false,
    imageFit: "contain",
    dropShadow: true
};
